/* Landing-page facet filters (safe, does not touch collection template JS) */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pp-facets-root]').forEach(function (root) {
    var form = root.querySelector('form[data-pp-facets-form]');
    var baseUrl = root.getAttribute('data-pp-collection-url');
    var sectionId = root.getAttribute('data-pp-section-id');

    if (!form || !baseUrl || !sectionId) return;

    var debounceTimer = null;

    function serializeForm() {
      var fd = new FormData(form);
      var sp = new URLSearchParams(fd);

      // remove empty params
      var emptyKeys = [];
      sp.forEach(function (v, k) {
        if (!v) emptyKeys.push(k);
      });
      emptyKeys.forEach(function (k) { sp.delete(k); });

      return sp.toString();
    }

    function apply(searchParams) {
      root.classList.add('is-loading');

      var url = baseUrl + (baseUrl.indexOf('?') >= 0 ? '&' : '?')
        + 'section_id=' + encodeURIComponent(sectionId)
        + (searchParams ? '&' + searchParams : '');

      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmpl = document.createElement('template');
          tmpl.innerHTML = html;

          // the response is the section HTML; find our root again inside it
          var nextRoot = tmpl.content.querySelector('[data-pp-facets-root]');
          if (!nextRoot) return;

          // replace the whole section root contents (keeps your page layout stable)
          root.replaceWith(nextRoot);

          // update page URL querystring (optional but useful)
          var newUrl = window.location.pathname + (searchParams ? '?' + searchParams : '');
          window.history.pushState({ searchParams: searchParams }, '', newUrl);
        })
        .catch(function (e) {
          console.error('[pp facets] fetch error', e);
        })
        .finally(function () {
          // nothing; root is replaced
        });
    }

    // Input change (checkboxes, price inputs, etc)
    form.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        apply(serializeForm());
      }, 350);
    });

    // Clear links inside active filters (if any)
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-pp-clear-url]');
      if (!a) return;
      e.preventDefault();

      var u = new URL(a.getAttribute('href'), window.location.origin);
      apply(u.searchParams.toString());
    });

    // Back/forward support
    window.addEventListener('popstate', function (evt) {
      if (evt.state && typeof evt.state.searchParams === 'string') {
        apply(evt.state.searchParams);
      }
    });
  });
});
